	app.factory('authService', ['$http', '$q', '$window', 'gameService', 'welcomeService', 'teacherAppService', 'messageService', 'appService', '$rootScope', function ($http, $q, $window, gameService, welcomeService, teacherAppService, messageService, appService, $rootScope) {
		var service = this;

		service.me = function() {
			return $http.get('api/me')
				.then(function (resp) {
					console.dir(resp.data);
					return resp.data;
				}, function (err) {
					console.log('api me error');
				});
		};

		service.authStatus = false;
		service.isTeacher = false;

		service.restart = function() {
			$http.post('/api/gameauth/logout').then(function(response) {
				service.tempPin = null;
				service.authStatus = false;
			});
		}

		service.tempPin = undefined;
		service.cookiePinCode = function() {
			if (service.tempPin != null) {
				return service.tempPin;
			}

			var cookie = $window.document.cookie;
			if (!cookie) {
				return null;
			}
			var idx = cookie.indexOf(".FDGAME=");
			if (idx < 0) {
				return null;
			}
			var sub = cookie.substring(idx);
			var end = sub.indexOf("; ");
			var pin = sub;
			if (end != -1) {
				pin = pin.substring(0, end);
			}
			return pin.substr(".FDGAME=".length);
		}

		service.isAuthenticated = function() {
			return $q(function(resolve, reject) {
				var cookiePin = service.cookiePinCode();
				var ok = cookiePin != null || (service.authStatus == true);
				resolve(ok);
			});
		}

		service.authenticateWithPin = function(pinCode) {
			return $q(function(resolve, reject) {
				$http.post('/api/gameauth/login', {'pin': pinCode}).then(function(response) {
					var obj = response.data;

					var setCookie = response.headers('Set-Cookie');
					$window.document.cookie = setCookie;

					console.log("setting initial state");
					gameService.setInitialState(obj);
					welcomeService.setInitialState(obj);
					console.log("done setting initial state");

					service.authStatus = true;
					service.isTeacher = response.data.permission.isTeacher;

					$rootScope.$broadcast('authServiceIsAuthenticated');

					// Update isTeacherApp/isStudentApp in appService
					// to reflect our currently login-status.
					if (service.isTeacher) {
						appService.isTeacherApp = true;
						appService.isStudentApp = false;
					} else {
						appService.isTeacherApp = false;
						appService.isStudentApp = true;
					}

					// Set a temp pin. This overrides the cookie
					// in cases where our page hasn't been reloaded
					// to set the cookie in window.cookies.
					service.tempPin = pinCode;

					messageService.startAndSyncImmediately().then(function() {
						console.log("started messageService...");
						if (service.isTeacher) {
							console.log("attempting to start teacherService...");
							teacherAppService.startAndSyncImmediately().then(function() {
								resolve(true);
							}, function() {
								resolve(false);
							});
						} else {
							resolve(true);
						}
					}, function() {
						resolve(false);
					});
				}, function() {
					resolve(false);
				});
			});
		}

		service.ensureGameDataIsLoaded = function() {
			return $q(function(resolve, reject) {
				if (gameService.ready) {
					resolve();
					return;
				}

				var pin = service.cookiePinCode();
				if (!pin) {
					reject("no pin");
				}
				service.authenticateWithPin(pin).then(function() {
					resolve();
				}, function() {
					reject();
				});
			});
		}

		return service;
	}]);